
    /**
     * @description
     *  Modelo de una consulta de morosidad.
     *
     * @see gigot-backend/Core/Query/DelinquencyQuery.cs
     */

export class DelinquencyQuery {

    public campaignIdFrom: number;
    public campaignIdTo: number;

	public areaId: number;
	public zoneId: number;
	public divisionId: number;
	public commerceId: number;
    public countryId: number;

    /**
     * @description
     *	Construye una consulta de morosidad con una semántica vacía. Nótese
	 *	que no es lo mismo que construir una consulta con valores por defecto.
	 *	Las reglas generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Una consulta vacía.
     */
    public static empty(): DelinquencyQuery {
        const delinquencyQuery: DelinquencyQuery = new DelinquencyQuery();
        delinquencyQuery.campaignIdFrom = undefined;
        delinquencyQuery.campaignIdTo = undefined;
		delinquencyQuery.areaId = undefined;
		delinquencyQuery.zoneId = undefined;
		delinquencyQuery.divisionId = undefined;
		delinquencyQuery.commerceId = undefined;
		delinquencyQuery.countryId = undefined;
        return delinquencyQuery;
    }
}
